import { render, staticRenderFns } from "./InstitutionEditTabUsers.vue?vue&type=template&id=25f2b4e2&"
import script from "./InstitutionEditTabUsers.vue?vue&type=script&lang=js&"
export * from "./InstitutionEditTabUsers.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionEditTabUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports